export default __webpack_public_path__ + "static/media/card-amex.8822bca9.svg";